import _ from 'lodash';
import { actions as loading } from './store/loading';
import { actions as error } from './store/error';

export default function load(requestId, handler, ...args) {
  let handlerArgs = args;
  let err = () => false;
  if (_.isFunction(_.last(args))) {
    handlerArgs = _.initial(args);
    err = _.last(args);
  }
  return async (dispatch, getState) => {
    try {
      dispatch(loading.loading(requestId));
      await handler(dispatch, getState(), ...handlerArgs);
      dispatch(loading.loaded(requestId));
      return true;
    } catch (ex) {
      if (!err(ex)) {
        dispatch(error.error(ex));
      } else {
        dispatch(loading.loaded(requestId));
      }
    }
    return false;
  };
}
